import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { MenuList } from 'components/common/MyCustomSelect/components/MenuList/MenuList';
import { OptionsWithExclude } from 'components/common/MyCustomSelect/components/OptionsWithExclude/OptionsWithExclude';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';

export const ActivityCodes = ({ options, onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();

    return (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Activity Codes</span>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<{ name: number; isExclude: boolean; alias: string | null }>, true>
                        id={'battlecards-filters-activity-codes'}
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        isMulti
                        options={options}
                        components={{
                            MenuList: MenuList,
                            Option: OptionsWithExclude,
                        }}
                        isLoading={isLoading}
                    />
                )}
                name={'activityCodes'}
                control={control}
            />
        </div>
    );
};
